import { Link, useNavigate } from "react-router-dom";
import { Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const PublicShell = ({ children }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-40 glass border-b border-border/60">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="h-9 w-9 rounded-xl bg-primary flex items-center justify-center"><Gift className="h-5 w-5 text-primary-foreground" /></div>
            <span className="font-head font-extrabold text-xl tracking-tight text-primary">Ti Regalo</span>
          </Link>
          <div className="flex items-center gap-2">
            <Button variant="ghost" onClick={() => navigate("/mappa")} className="rounded-full" data-testid="public-map-link">Mappa</Button>
            {user ? (
              <Button onClick={() => navigate("/app")} className="rounded-full" data-testid="public-app-btn">La mia area</Button>
            ) : (
              <>
                <Button variant="ghost" onClick={() => navigate("/login")} className="rounded-full" data-testid="public-login-btn">Accedi</Button>
                <Button onClick={() => navigate("/register")} className="rounded-full" data-testid="public-register-btn">Iscriviti</Button>
              </>
            )}
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8">{children}</main>
    </div>
  );
};

export default PublicShell;
